import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import classnames from 'classnames';


const ConnectedUsers = ({data, privateChatUser, setParticipant, refreshConnectedUsersList}) =>{
    const connectedUsers = data;
    const show = useSelector(store=>store.ui.connectedUsersBarShow);

    return(
        <Card className={classnames('h-100 flex-shrink-0 rounded-0 bg-light', {'d-none': !show})}>
            <Card.Header className='font-weight-bold px-2 py-1'>
                Connected: {connectedUsers.length}
            </Card.Header>
            <Card.Body className ='px-0 py-0 font12'>
                <div 
                    onClick={()=>setParticipant('')} 
                    className={classnames('border px-2 mx-0 py-3 mb-3 pointer', {'text-white bg-dark': !privateChatUser.publicId})}
                >
                    Public Chat
                </div>
                {connectedUsers.map((user,idx)=>(
                    <div 
                        key={idx} 
                        onClick={()=>setParticipant(connectedUsers[idx])} 
                        className={classnames('border px-2 py-2 pointer overflow-auto',{'text-white bg-dark': user.publicId === privateChatUser.publicId})}>
                        {
                           user?.avatar && <img className='rounded-circle mr-2' src={require(`./../../avatars/${user.avatar}.png`).default} width={40} alt='av'/>
                        }
                        {user?.name}
                    </div>
                ))}
            </Card.Body>
            <Button variant='light' size='sm' onClick={refreshConnectedUsersList} className='font8 py-1'>reload</Button>
        </Card>
    )
}


export default ConnectedUsers;